import React, { memo } from 'react'
import LogoLoop from './LogoLoop'
import useClientLogos from './clients/useClientLogos'
import ClientLogoBox from './clients/ClientLogoBox'
import '../styles/clientLogos.scss'

/**
 * Client logo marquee — every client in src/data/clientLogos.js, in that
 * file's own order, plus one extra render of Muscat Media Group at the
 * end (it appeared twice before; the marquee reads better for it, so this
 * keeps that rather than regress it now that the master list only lists
 * each real client once).
 *
 * Each logo's box is sized from its own file's aspect ratio (very-wide /
 * wide / square-ish / tall — src/components/clients/clientLogoBand.js,
 * src/styles/clientLogos.scss), via LogoLoop's `renderItem`, so this no
 * longer pins every logo to one fixed 220x80 slot the way it used to.
 */
const MUSCAT_REPEAT = "Muscat Media Group"

const HappyClients = () => {
  const clientLogos = useClientLogos()

  const items = [...clientLogos, clientLogos.find(c => c.name === MUSCAT_REPEAT)]
    .filter(Boolean)
    .filter(client => !client.caseStudyOnly)
    .map((client, i) => ({ client, key: `${client.name}-${i}` }))
    .filter(item => item.client.logoImage)

  return (
    <section className="tc-section">
      {/* "Worldwide" stays gone — it was a scale claim, and the retired hero
          band's "4 Continents Served" was dropped for the same reason (see the
          NOT INCLUDED note in HomePageIntro.js). No scale word replaces it.

          COUNT CONFIRMED AT 25 BY THE BRIEF. src/data/clientLogos.js has 36
          distinct clients, comfortably past the "more than 25" claim.

          The split matches the previous structure exactly: "Trusted by" at full
          size, the rest in the accent span, which clients.scss sets at under
          half the heading size. */}
      <h2 className="tc-heading">
        Trusted by{" "}
        <span className="tc-heading__accent">more than 25 organizations</span>
      </h2>
      <p className="tc-sub">
        Enterprises across the Middle East, Europe, and North America rely on Visiomate
        to build, optimize, and scale their technology.
      </p>
      <div style={{ height: '140px', position: 'relative', overflow: 'hidden' }}>
        <LogoLoop
          logos={items}
          speed={100}
          direction="left"
          gap={40}
          hoverSpeed={0}
          scaleOnHover
          fadeOut
          fadeOutColor="#ffffff"
          ariaLabel="Happy clients"
          renderItem={item => <ClientLogoBox client={item.client} />}
        />
      </div>
    </section>
  )
}

export default memo(HappyClients)
